var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00034 6.67926L10.8208 1.61968C11.0533 1.37567 11.0477 0.985506 10.8083 0.748243L10.2295 0.174401C9.99058 -0.0624831 9.60887 -0.0575014 9.37622 0.185543L5.53767 4.19561L1.58634 0.296642C1.34686 0.060331 0.965161 0.0662369 0.733072 0.309838L0.170845 0.899954C-0.0616409 1.14397 -0.0560764 1.53413 0.183273 1.7714L5.14604 6.69142C5.38537 6.92871 5.76785 6.92326 6.00034 6.67926Z",
    fill: "#103575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.f28f23a6ac9f8f84ca242adf29993019.svg";
export { ForwardRef as ReactComponent };